/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Khushalkumar Gondaliya",
  title: "Hi, I'm Khushal",
  subTitle:
    "Backend Systems Architect | High-Concurrency Distributed Systems Expert\n\n5+ years designing scalable microservices with Java (Spring Boot), Python, AWS & Azure | Kafka | Microservices & Cloud-Native Architecture | System Design (HLD/LLD) | IAM & Real-Time Observability",
  resumeLink:
    "/resume.pdf",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Khushal020",
  linkedin: "https://www.linkedin.com/in/khushal020",
  gmail: "khushalgondaliya020@gmail.com",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "BACKEND SYSTEMS ARCHITECT | HIGH-CONCURRENCY DISTRIBUTED SYSTEMS | MICROSERVICES & CLOUD-NATIVE ARCHITECTURE",
  skills: [
    emoji(
      "⚡ Design and architect scalable backend systems using Java (Spring Boot) with multithreaded optimization, RESTful (Representational State Transfer) APIs, and high-concurrency patterns"
    ),
    emoji(
      "⚡ Engineer full-text search engines and high-performance indexing solutions using Apache Lucene for large-scale data retrieval at enterprise scale"
    ),
    emoji(
      "⚡ Build event-driven microservices with Apache Kafka, implementing async messaging patterns, exactly-once semantics, and Dead-Letter Queues (DLQs) for resilient systems"
    ),
    emoji(
      "⚡ Develop serverless ETL (Extract, Transform, Load) architectures with Python and AWS Lambda, automating data processing and cloud infrastructure"
    ),
    emoji(
      "⚡ Implement enterprise IAM (Identity & Access Management) systems using Azure Active Directory (AD) and Microsoft Graph API for secure user lifecycle management"
    ),
    emoji(
      "⚡ Deploy cloud-native applications on AWS (ECS, Lambda, S3, RDS) and Azure, orchestrating with Docker and Kubernetes for production reliability"
    ),
    emoji(
      "⚡ Engineer real-time observability using Prometheus, Grafana, and distributed tracing for proactive monitoring and rapid incident response"
    ),
    emoji(
      "⚡ Lead system design and architecture, transforming business requirements into scalable HLD (High-Level Design) and LLD (Low-Level Design) documentation"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // Backend Languages & Frameworks (PRIMARY)
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring Boot",
      fontAwesomeClassname: "devicon-spring-plain"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    // Messaging & Event Streaming
    {
      skillName: "Apache Kafka",
      fontAwesomeClassname: "devicon-apachekafka-original"
    },
    // Databases
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "devicon-postgresql-plain"
    },
    {
      skillName: "Redis",
      fontAwesomeClassname: "devicon-redis-plain"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    // Cloud & Infrastructure
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "devicon-kubernetes-plain"
    },
    {
      skillName: "Terraform",
      fontAwesomeClassname: "devicon-terraform-plain"
    },
    // APIs & Backend Tools
    {
      skillName: "GraphQL",
      fontAwesomeClassname: "devicon-graphql-plain"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Jenkins",
      fontAwesomeClassname: "devicon-jenkins-plain"
    },
    // Frontend (Secondary)
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "devicon-typescript-plain"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Dalhousie University",
      logo: require("./assets/images/dal.png"),
      subHeader: "Master of Applied Computer Science",
      duration: "May 2022 – August 2023",
      desc: "GPA – 4.2 / 4.3"
    },
    {
      schoolName: "Gujarat Technological University",
      logo: require("./assets/images/gtu.png"),
      subHeader: "Bachelor of Engineering in Computer Engineering",
      duration: "August 2016 – August 2020",
      desc: "GPA – 8.6 / 10"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Engineering (Java / Spring Boot)",
      progressPercentage: "90%"
    },
    {
      Stack: "SQL / NoSQL Databases",
      progressPercentage: "88%"
    },
    {
      Stack: "Event Streaming & Messaging (Kafka / Redis)",
      progressPercentage: "85%"
    },
    {
      Stack: "Cloud & DevOps (AWS / Docker / K8s)",
      progressPercentage: "85%"
    },
    {
      Stack: "Frontend (React / TypeScript)",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer II",
      company: "Gaming Labs International",
      companylogo: require("./assets/images/gli-logo.jpeg"),
      date: "January 2024 – Present",
      desc: "Backend systems architect designing scalable microservices for high-concurrency compliance and transaction processing at scale. Lead backend architecture decisions with focus on performance, reliability, and operational excellence.",
      descBullets: [
        "Architected Java 17 + Spring Boot 3.x microservices with event-driven patterns; designed system for handling high transaction volumes using Apache Kafka with exactly-once semantics and Dead-Letter Queues (DLQs).",
        "Engineered multi-tier caching strategy with Redis L1 cache and PostgreSQL L2; optimized SQL queries with proper indexing, connection pooling, and prepared statements; achieved sub-100ms response times at high concurrency.",
        "Designed for high-concurrency: implemented thread-safe patterns, connection management, and backpressure handling; profiled application for bottlenecks using JFR (Java Flight Recorder) and optimized hot paths.",
        "Built resilient systems with circuit breakers, retry logic, and fallback patterns; implemented comprehensive error handling and recovery mechanisms for production stability.",
        "Deployed microservices on AWS ECS Fargate with Kubernetes orchestration; configured auto-scaling policies based on metrics; set up distributed tracing and centralized logging for production observability."
      ]
    },
    {
      role: "Software Developer Co-op",
      company: "Tulip Inc.",
      companylogo: require("./assets/images/tulip.png"),
      date: "May 2023 – August 2023",
      desc: "Developed backend services and database-intensive features for retail operations platform. Focused on performance optimization and production readiness through rigorous testing.",
      descBullets: [
        "Developed Java (Spring Boot) backend services for retail platform; implemented RESTful APIs handling retail transaction flows with proper error handling and validation.",
        "Optimized PostgreSQL performance: analyzed slow queries using EXPLAIN ANALYZE, added strategic indexes, optimized JOIN patterns, configured connection pooling (HikariCP); improved query latency by 60%.",
        "Applied Test-Driven Development (TDD) throughout: wrote unit tests with JUnit 5, integration tests, and mock dependencies with Mockito; achieved 85%+ test coverage.",
        "Deployed services through CI/CD pipeline using Jenkins and Docker; participated in on-call rotation; debugged production issues and implemented fixes; collaborated on code reviews and knowledge sharing."
      ]
    },
    {
      role: "Data Engineer Intern",
      company: "Webonise Technologies",
      companylogo: require("./assets/images/webonise.png"),
      date: "July 2022 – April 2023",
      desc: "Built serverless backend architecture for data processing at scale. Developed Python-based data pipelines and infrastructure-as-code for multi-region deployments.",
      descBullets: [
        "Designed and implemented AWS Lambda-based ETL backend using Python; processed large data volumes with S3 for storage and SQS for asynchronous task queuing; implemented proper error handling and Dead-Letter Queues (DLQs).",
        "Architected backend for data platform: designed MongoDB schemas with proper indexing strategies; optimized queries for analytical workloads; enabled real-time data retrieval.",
        "Implemented Infrastructure-as-Code using Terraform and CloudFormation; automated service deployment across multiple AWS regions; managed RDS, Lambda, S3, and networking resources.",
        "Built serverless backend patterns: stateless function design, event-driven processing, cost optimization through reserved capacity and spot instances."
      ]
    },
    {
      role: "Full Stack Engineering Analyst",
      company: "Accenture Solutions",
      companylogo: require("./assets/images/accenture.png"),
      date: "March 2021 – April 2022",
      desc: "Built enterprise-grade microservices for Fortune 500 clients. Designed cloud-native systems with emphasis on scalability, reliability, and production-ready implementations.",
      descBullets: [
        "Designed and implemented Spring Boot microservices with asynchronous messaging patterns using Azure Service Bus; built RESTful APIs handling 50K+ daily requests for enterprise clients.",
        "Optimized database design in Azure Cosmos DB: implemented proper indexing strategies, partition key design, and query optimization; designed schemas for scalability supporting millions of records.",
        "Mentored junior developers on microservices architecture patterns, code quality, and best practices; led architecture reviews for client teams; established engineering standards and CI/CD practices.",
        "Implemented enterprise security: OWASP Top 10 compliance, input validation, secure API design; set up Jenkins CI/CD pipelines with automated testing and deployment gates.",
        "Built TensorFlow-based image classification model as supporting service; integrated ML pipeline with backend microservices infrastructure."
      ]
    },
    {
      role: "Machine Learning Engineer Intern",
      company: "SCAAI",
      companylogo: require("./assets/images/scaai.png"),
      date: "February 2020 – June 2020",
      desc: "Early career: Explored machine learning and Python development. Built data pipelines and ML models for content classification.",
      descBullets: [
        "Developed Python backend pipeline for data collection: built web scraper using Selenium, implemented data cleaning and preprocessing, structured data for ML training.",
        "Trained TensorFlow-based text classification models; evaluated model performance; implemented feature engineering techniques.",
        "Collaborated on ML project architecture: understood data pipeline requirements, model serving considerations, and integration with backend systems."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Notable Projects",
  subtitle: "REAL-WORLD PROJECTS BUILT FROM ACTUAL PROFESSIONAL EXPERIENCE",
  projects: [
    {
      image: require("./assets/images/idencis-pos.png"),
      projectName: "Multi-Tenant POS & E-Commerce Platform (Current Production)",
      projectDesc:
        "Built production-grade multi-tenant Point of Sale (POS) and e-commerce platform serving multiple merchant businesses. Architected scalable backend handling concurrent transactions across multiple storefronts with tenant isolation and data security. Implemented platform integrations with major e-commerce giants: Shopify, Amazon, and Flipkart for unified inventory and order management. Built real-time sync mechanisms for inventory updates across multiple platforms. Designed multi-tenant database architecture ensuring data isolation while optimizing for query performance. Deployed on cloud infrastructure with auto-scaling for peak transaction volumes. Engineered admin dashboard for merchant analytics, reporting, and platform management.",
      projectTechStack:
        "Java · Spring Boot · Multi-Tenant Architecture · PostgreSQL · Redis · Shopify API · Amazon SP-API · Flipkart API · Docker · AWS",
      projectLink: null,
      projectUrl: "https://www.idencis.ca",
      metrics: "Production platform · Multi-tenant · 3x platform integrations · Real-time sync"
    },
    {
      image: require("./assets/images/microservices-platform.svg"),
      projectName: "Concurrent Transaction Processing System",
      projectDesc:
        "Personal learning project to understand high-concurrency system design and performance optimization. Built a Java Spring Boot microservices system to solve real problem: handling concurrent user transactions with minimal latency. Experimented with event-driven patterns using Apache Kafka for async processing and implemented multi-tier caching strategy (Redis L1, PostgreSQL L2) to reduce database load. Learned about Docker containerization and AWS ECS deployment. Implemented circuit breakers and connection pooling to gracefully handle traffic spikes. Solved real challenges: query performance optimization, efficient database connection management, and handling concurrent requests at scale. Practical outcome: developed deep understanding of bottlenecks in high-load systems and key considerations for designing scalable backend architectures.",
      projectTechStack:
        "Java · Spring Boot · Apache Kafka · Redis · PostgreSQL · Docker · AWS",
      projectLink: null,
      metrics: "Personal project · Real-world scalability · Concurrent request handling · Query optimization"
    },
    {
      image: require("./assets/images/foodo.png"),
      projectName: "Retail Operations Platform Backend",
      projectDesc:
        "Built backend services for production retail operations platform. Developed Java Spring Boot microservices handling retail transactions and inventory operations. Optimized PostgreSQL queries using EXPLAIN ANALYZE, implemented strategic indexing, and configured HikariCP connection pooling (improved latency 60%). Applied Test-Driven Development (TDD) throughout: JUnit 5 unit tests, Mockito mocks, integration testing (85%+ coverage). Deployed through Jenkins CI/CD pipeline; participated in on-call rotation and production debugging.",
      projectTechStack:
        "Java · Spring Boot · PostgreSQL · JUnit 5 · Mockito · Jenkins · Docker",
      projectLink: null,
      metrics: "Production platform · 85%+ test coverage · 60% latency improvement · On-call support"
    },
    {
      image: require("./assets/images/halifax-foodie.png"),
      projectName: "Serverless Backend Data Pipeline",
      projectDesc:
        "Architected Python-based serverless backend for large-scale data processing. Designed AWS Lambda functions handling data ingestion from multiple sources into S3. Implemented event-driven pipeline: S3 triggers Lambda functions for transformation and enrichment. Built fault-tolerant patterns: DLQs (Dead-Letter Queues) for failed messages, exponential backoff retries, and comprehensive error handling. Stored processed data in MongoDB with proper indexing for analytics queries. Infrastructure-as-Code: Terraform and CloudFormation for multi-region deployment. Optimized for cost using reserved capacity and spot instances.",
      projectTechStack:
        "Python · AWS Lambda · S3 · SQS · MongoDB · Terraform · CloudFormation",
      projectLink: null,
      metrics: "Production pipeline · Multi-region · Cost-optimized · Event-driven architecture"
    },
    {
      image: require("./assets/images/git.png"),
      projectName: "Enterprise Microservices Architecture",
      projectDesc:
        "Designed and implemented cloud-native microservices backend for Fortune 500 clients. Architected Spring Boot microservices handling 50K+ API requests daily with async messaging (Azure Service Bus). Designed database schemas and indexing strategies in Azure Cosmos DB for optimal query performance and cost efficiency. Implemented enterprise security: OWASP Top 10 compliance, input validation, secure API design, authentication/authorization. Built Jenkins CI/CD pipelines with automated testing and deployment gates. Mentored junior developers on microservices patterns, code reviews, and best practices.",
      projectTechStack:
        "Java · Spring Boot · Azure Service Bus · Azure Cosmos DB · Docker · Kubernetes · Jenkins",
      projectLink: null,
      metrics: "Enterprise scale · 50K+ API requests/day · Team mentoring · Security-first design"
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Professional Development 🎓"),
  subtitle:
    "Continuous learning through hands-on experience with modern cloud platforms, distributed systems, and best practices.",

  achievementsCards: [
    {
      title: "AWS Cloud Expertise",
      subtitle:
        "Proficiency in AWS services including Lambda, ECS, S3, RDS, and IAM. Built and deployed multiple production systems on AWS infrastructure with focus on scalability and cost optimization.",
      image: require("./assets/images/awsccp.png"),
      imageAlt: "AWS Badge",
      footerLink: []
    },
    {
      title: "Java Microservices with Spring Boot By Coursera",
      subtitle:
        "Deep expertise in building scalable microservices with Spring Boot, implementing distributed systems patterns, and designing for high concurrency and fault tolerance.",
      image: require("./assets/images/coursera.png"),
      imageAlt: "Coursera Spring Boot Certification",
      footerLink: []
    },
    {
      title: "Data Engineering & Python",
      subtitle:
        "Built serverless ETL pipelines and data processing systems using Python, AWS Lambda, and cloud-native architectures for automated data workflows.",
      image: require("./assets/images/jovian.png"),
      imageAlt: "Python & Data Engineering",
      footerLink: []
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Technical Articles",
  subtitle:
    "In-depth articles on microservices architecture, event-driven systems, cloud infrastructure, and distributed systems design.",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY KNOWLEDGE AND GET A SPEAKER BADGE 😅"),
  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Have a project idea or want to discuss opportunities? My inbox is always open.",
  number: "+1 (782) 882-1509",
  email_address: "khushalgondaliya020@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Open to opportunities

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
